import { cyan, green, red, yellow } from "kleur/colors"

export const highlighter = {
  error: red,
  warn: yellow,
  info: cyan,
  success: green,
}
